// Admin.jsx

import { useEffect, useState } from "react";
import axios from "axios";
import "./admin.css";
import AdminOrders from "./AdminOrders";
export default function Admin() {

  const role = localStorage.getItem("role");

  const [activeTab, setActiveTab] = useState("dashboard");

  const [products, setProducts] = useState([]);

  const [name, setName] = useState("");
  const [price, setPrice] = useState("");
  const [category, setCategory] = useState("");
  const [description, setDescription] = useState("");
  const [brand, setBrand] = useState("");

  const [image, setImage] = useState(null);

  const [editingId, setEditingId] = useState(null);

  const [preview, setPreview] = useState("");
const [oldImage, setOldImage] = useState("");
  // GET PRODUCTS
  const getProducts = async () => {

    try {

      const res = await axios.get(
        "https://apple2.shopat1stop.com/api/products"
      );

      setProducts(res.data);

    } catch (err) {
      console.log(err);
    }
  };

  // REALTIME REFRESH
 useEffect(() => {

  getProducts();

  const interval = setInterval(() => {
    getProducts();
  }, 3000);

  return () => clearInterval(interval);

}, []);

  // ACCESS DENIED
if (role !== "admin") {

  window.location.href = "/admin";

  return null;
}
  // ADD OR UPDATE PRODUCT
  const addProduct = async (e) => {

    e.preventDefault();

    try {

      let imagePath = oldImage;

      // IMAGE UPLOAD
      if (image) {

        const formData = new FormData();

        formData.append("image", image);

        const uploadRes = await axios.post(
          "https://apple2.shopat1stop.com/api/upload",
          formData
        );

        imagePath = uploadRes.data.image;
      }

      // UPDATE PRODUCT
      if (editingId) {

        await axios.put(
          `https://apple2.shopat1stop.com/api/product/${editingId}`,
          {
            name,
            price,
            category,
            description,
            brand,
            image: imagePath
          }
        );

        alert("Product Updated ✅");

      } else {

        // ADD PRODUCT
        await axios.post(
          "https://apple2.shopat1stop.com/api/add-product",
          {
            name,
            price,
            category,
            description,
            brand,
            rating: 4.5,
            image: imagePath
          }
        );

        alert("Product Added ✅");
      }

      // RESET FORM
      setName("");
      setPrice("");
      setCategory("");
      setDescription("");
      setBrand("");
      setImage(null);
      setPreview("");
      setOldImage("");
      setEditingId(null);

      getProducts();

      setActiveTab("products");

    } catch (err) {
      console.log(err);
    }
  };

  // DELETE PRODUCT
  const deleteProduct = async (id) => {

    try {

      await axios.delete(
        `https://apple2.shopat1stop.com/api/product/${id}`
      );

      alert("Deleted ✅");

      getProducts();

    } catch (err) {
      console.log(err);
    }
  };

  // EDIT PRODUCT
  
const editProduct = (item) => {

  setEditingId(item.id);

  setName(item.name);
  setPrice(item.price);
  setCategory(item.category);
  setDescription(item.description);
  setBrand(item.brand);

  setOldImage(item.image);

  setPreview(
    `https://apple2.shopat1stop.com${item.image}`
  );

  setActiveTab("add");
};

  return (

    <div className="admin-page">

      {/* SIDEBAR */}
      <div className="admin-sidebar">

        <h2>🍃 Admin</h2>

        <button
          className={
            activeTab === "dashboard"
              ? "sidebar-btn active"
              : "sidebar-btn"
          }
          onClick={() =>
            setActiveTab("dashboard")
          }
        >
          📊 Dashboard
        </button>

        <button
          className={
            activeTab === "add"
              ? "sidebar-btn active"
              : "sidebar-btn"
          }
          onClick={() =>
            setActiveTab("add")
          }
        >
          ➕ Add Product
        </button>

        <button
          className={
            activeTab === "products"
              ? "sidebar-btn active"
              : "sidebar-btn"
          }
          onClick={() =>
            setActiveTab("products")
          }
        >
          📦 Products
        </button>
<button
  className={
    activeTab === "orders"
      ? "sidebar-btn active"
      : "sidebar-btn"
  }
  onClick={() =>
    setActiveTab("orders")
  }
>
  📋 Orders
</button>
<button
  className="logout-btn"
  onClick={() => {

    localStorage.removeItem("token");
    localStorage.removeItem("role");
    localStorage.removeItem("user_id");
    localStorage.removeItem("name");

    window.location.href = "/admin";
  }}
>
  🚪 Logout
</button>
      </div>



      {/* CONTENT */}
      <div className="admin-content">

        {/* DASHBOARD */}
        {activeTab === "dashboard" && (

          <div>

            <h1>Dashboard</h1>

            <div className="stats-grid">

              <div className="stat-card">
                <h3>Total Products</h3>
                <p>{products.length}</p>
              </div>

              <div className="stat-card">
                <h3>Total Categories</h3>
                <p>18</p>
              </div>

              <div className="stat-card">
                <h3>Total Orders</h3>
                <p>0</p>
              </div>

            </div>

          </div>
        )}

        {/* ADD PRODUCT */}
        {activeTab === "add" && (

          <div className="admin-form-section">

            <h2>
              {editingId
                ? "Update Product"
                : "Add Product"}
            </h2>

            <form onSubmit={addProduct}>

              <input
                type="text"
                placeholder="Product Name"
                value={name}
                onChange={(e) =>
                  setName(e.target.value)
                }
                required
              />

              <input
                type="number"
                placeholder="Price"
                value={price}
                onChange={(e) =>
                  setPrice(e.target.value)
                }
                required
              />

              <select
                value={category}
                onChange={(e) =>
                  setCategory(e.target.value)
                }
                required
              >

                <option value="">
                  Select Category
                </option>

                <option>Kratom Powder</option>
                <option>Kratom Capsules</option>
                <option>Kratom Extract</option>

                <option>CBD Gummies</option>
                <option>CBD Oils</option>
                <option>CBD Flower</option>

                <option>THC Gummies</option>
                <option>THC Vapes</option>
                <option>THCA Flower</option>

                <option>Delta 9 Gummies</option>
                <option>Delta 9 Vape</option>
                <option>Delta 9 Flower</option>

                <option>Grinders</option>
                <option>Pre-Rolls</option>
                <option>Vape Pens</option>
                <option>Accessories</option>

                <option>Blue Lotus</option>
                <option>7-Hydroxy</option>

              </select>

              <input
                type="text"
                placeholder="Brand"
                value={brand}
                onChange={(e) =>
                  setBrand(e.target.value)
                }
              />

              <textarea
                placeholder="Description"
                value={description}
                onChange={(e) =>
                  setDescription(e.target.value)
                }
              />

              <input
                type="file"
                onChange={(e) => {

                  setImage(
                    e.target.files[0]
                  );

                  if (e.target.files[0]) {

                    setPreview(
                      URL.createObjectURL(
                        e.target.files[0]
                      )
                    );
                  }
                }}
              />

              {preview && (
                <img
                  src={preview}
                  alt=""
                  className="preview-image"
                />
              )}

              <button type="submit">

                {editingId
                  ? "Update Product"
                  : "Add Product"}

              </button>

            </form>

          </div>
        )}

        {/* PRODUCTS */}
        {activeTab === "products" && (

          <div className="products-section">

            <h2>All Products</h2>

            <div className="products-grid">

             {products.map((item) => (

  <div
    className="product-card"
    key={item.id}
  >

    <img
      src={
        item.image
          ? `https://apple2.shopat1stop.com${item.image}`
          : "https://via.placeholder.com/300"
      }
      alt={item.name}
    />

    <div className="product-info">

      <h3>{item.name}</h3>

      <p>${item.price}</p>

      <span>{item.category}</span>

      <div className="product-buttons">

        <button
          className="edit-btn"
          onClick={() =>
            editProduct(item)
          }
        >
          Edit
        </button>

        <button
          className="delete-btn"
          onClick={() =>
            deleteProduct(item.id)
          }
        >
          Delete
        </button>

      </div>

    </div>

  </div>
))}

            </div>

          </div>
        )}
{activeTab === "orders" && (
  <AdminOrders />
)}
      </div>

    </div>
  );
}